// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//export const baseUrl = 'backend-api/api';
export const baseUrl = 'https://simulatupension-qa.confuturo.cl/backend-api/api';
export const destinationEmail = 'cguzmans@confuturo.cl';
export const key = 'b14ca5898a4e4133';
export const emailImgUrl =
  'https://simulatupension-qa.confuturo.cl/assets/images/email';

export const environment = {
  production: false,
  baseUrl,
  destinationEmail,
  key,
  emailImgUrl,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
